export default "__VITE_ASSET__4ucq$_09__"